<template>
  <!-- Modal -->
  <div class="new-order-modal-container">
    <p-modal
      :name="modalName"
      :width="648"
      @before-open="fetchNewOrderModalData"
      @before-close="clearOrder"
    >
      <div
        class="new-order-modal"
      >
        <h4 class="text-center mb-4">
          {{ isEdit ? 'Edit' : 'New' }} Order
        </h4>
        <div
          v-if="isAdmin || isRep"
          class="d-flex align-items-center contact-buttons"
        >
          <p-button
            class="text-capitalize me-3"
            style="padding: 8px 0; width: 127px;"
            @click="onEditContactBtnClicked"
          >
            Edit Contact
          </p-button>
          <p-button
            class="text-capitalize"
            style="padding: 8px 0; width: 127px;"
            @click="onNewContactBtnClicked"
          >
            New Contact
          </p-button>
        </div>
        <form
          class="new-order-modal-form"
          @submit.prevent="handleSaveNewOrder"
        >
          <div
            :class="(isAdmin || isRep) ? 'row mb-4' : 'row mb-3'"
          >
            <div class="col-md-12">
                <SearchDropDown
                    v-if="isAdmin || isRep"
                    v-model.number="formData.company_id"
                    :options="companyItems"
                    :searchable="true"
                    labelText="Company Name"
                    :required="false"
                    @input="changeCompany(formData.company_id)"
                />
              <div v-else>
                <label
                  for=""
                  class="form-label label-form"
                >Customer's Store Name:</label>
                <p
                  class="mb-0"
                >
                  {{ companyName }}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-4">
              <div>
                <p-v-select
                  v-model.number="formData.billing_address_id"
                  :data-value="formData.billing_address_id"
                  :options="billToItems"
                  label-text="Bill To:"
                  :reduce="address => address.address_id"
                  required
                  :label-el-props="{
                    class: 'label-form'
                  }"
                  label="optionLabel"
                >
                  <template #selected-option="row">
                    <div class="selected-option">
                      <p>{{ row.name_description }}</p>
                      <p>{{ row.address_one }}</p>
                      <p>{{ row.city }}, {{ row.state }} {{ row.zip }}</p>
                    </div>
                  </template>

                  <template #option="row">
                    <div class="label-row-container">
                      <p :class="row.address_id === formData.billing_address_id ? 'fw-bold' : ''">
                        {{ row.name_description }}
                      </p>
                      <p :class="row.address_id === formData.billing_address_id ? 'fw-bold' : ''">
                        {{ row.address_one }} {{ row.address_two }}
                      </p>
                      <p :class="row.address_id === formData.billing_address_id ? 'fw-bold' : ''">
                        {{ row.city }}, {{ row.state }} {{ row.zip }}
                      </p>
                    </div>
                  </template>
                </p-v-select>
              </div>
            </div>
            <div class="col-md-6 mb-4">
              <div>
                <p-v-select
                  v-model.number="formData.shipping_address_id"
                  :data-value="formData.shipping_address_id"
                  :options="shipToItems"
                  label-text="Ship To:"
                  :reduce="address => address.address_id"
                  required
                  :label-el-props="{
                    class: 'label-form'
                  }"
                  label="optionLabel"
                >
                  <template #selected-option="row">
                    <div class="selected-option">
                      <p>{{ row.name_description }}</p>
                      <p>{{ row.address_one }}</p>
                      <p>{{ row.city }}, {{ row.state }} {{ row.zip }}</p>
                    </div>
                  </template>

                  <template #option="row">
                    <div class="label-row-container">
                      <p :class="row.address_id === formData.shipping_address_id ? 'fw-bold' : ''">
                        {{ row.name_description }}
                      </p>
                      <p
                        :class="row.address_id === formData.shipping_address_id ? 'fw-bold' : ''"
                      >
                        {{ row.address_one }} {{ row.address_two }}
                      </p>
                      <p :class="row.address_id === formData.shipping_address_id ? 'fw-bold' : ''">
                        {{ row.city }}, {{ row.state }} {{ row.zip }}
                      </p>
                    </div>
                  </template>
                </p-v-select>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div
              v-if="showBuyerDropdown"
              class="col-6 col-md-6 mb-4 "
            >
              <div>
                <p-v-select
                  v-model.number="formData.buyer_id"
                  :data-value="formData.buyer_id"
                  :options="buyerItems"
                  label-text="Buyer"
                  :reduce="buyer => buyer.buyer_id"
                  required
                  :label-el-props="{
                    class: 'label-form'
                  }"
                  label="optionLabel"
                >
                  <template #selected-option="row">
                    <div class="selected-option">
                      <p>{{ row.first_name }} {{ row.last_name }}</p>
                      <p>{{ row.phone_number }}</p>
                      <p>{{ row.email }}</p>
                    </div>
                  </template>

                  <template #option="row">
                    <div class="label-row-container">
                      <p :class="row.buyer_id === formData.buyer_id ? 'fw-bold' : ''">
                        {{ row.first_name }} {{ row.last_name }}
                      </p>
                      <p :class="row.buyer_id === formData.buyer_id ? 'fw-bold' : ''">
                        {{ row.phone_number }}
                      </p>
                      <p :class="row.buyer_id === formData.buyer_id ? 'fw-bold' : ''">
                        {{ row.email }}
                      </p>
                    </div>
                  </template>
                </p-v-select>
              </div>
            </div>
            <div class="col-6 col-md-6 mb-4">
              <div :class="showBuyerDropdown ? 'mb-4' : ''">
                <pvc-datepicker
                  id="start-ship-date"
                  v-model="formData.start_ship_date"
                  mode="date"
                  :masks="{
                    inputDateTime: 'MM/DD/YYYY'
                  }"
                  required
                  label="Start Ship:"
                  :label-el-props="{
                    class: 'label-form'
                  }"
                />
              </div>
              <div v-if="showBuyerDropdown">
                <text-field
                  id="ref-note"
                  v-model="formData.ref_note"
                  label="Ref Note:"
                  :label-el-props="{
                    class: 'label-form'
                  }"
                  :maxlength="25"
                />
              </div>
            </div>
            <div
              v-if="!showBuyerDropdown"
              class="col-6 col-md-6 mb-4"
            >
              <text-field
                id="ref-note"
                v-model="formData.ref_note"
                label="Ref Note:"
                :label-el-props="{
                  class: 'label-form'
                }"
                :maxlength="25"
              />
            </div>
          </div>
          <div class="button-group d-flex align-items-center justify-content-center mt-3">
            <p-button
              class="text-capitalize me-2"
              style="padding: 10px 0; width: 145px;"
              :disabled="formLoading"
            >
              {{ formLoading ? 'Starting...' : 'Start' }}
            </p-button>

            <p-button
              type="button"
              class="text-capitalize me-2 cancel-btn"
              :disabled="formLoading"
              @click="closeModal"
            >
              Cancel
            </p-button>
          </div>
        </form>
      </div>
    </p-modal>
  </div>
</template>

<script>
import PModal from '~/components/core/PModal'
import PButton from '~/components/core/PButton'
import PSelect from '~/components/core/Inputs/PSelect'
import TextField from '~/components/core/Inputs/TextField'
import PvcDatepicker from '~/components/core/Inputs/PvcDatepicker'
import dayjs from 'dayjs'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { ORDER_STATUS } from '~/constants'
import orderRelated from '~/mixins/orderRelated'
import {
  SET_ADD_EDIT_ORDER_MODAL_WITH_CREATE_ACTIVE_ORDER_PRODUCT,
  CLEAR_SELECTED_PRODUCTS
} from '~/store/mutation-types'
import PVSelect from '~/components/core/Inputs/PVSelect'
import SearchDropDown from '~/components/core/Dropdown/SearchDropDown.vue'

export default {
  name: 'NewOrderModal',
  components: { SearchDropDown, PVSelect, PvcDatepicker, TextField, PSelect, PButton, PModal },
  mixins: [orderRelated],
  props: {
    modalName: {
      type: String,
      default: 'new-order-modal'
    },
    productIds: {
      type: Array,
      default: () => {}
    },
    actionType: {
      type: String,
      default: null
    }
  },
  data: () => ({
    formLoading: false,
    active_order_id: null,
    formData: {
      company_id: null,
      shipping_address_id: null,
      billing_address_id: null,
      buyer_id: null,
      start_ship_date: null,
      ref_note: '',
      discount: ''
    },
    companyItems: [],
    billToItems: [],
    shipToItems: [],
    buyerItems: [],
    companyName: ''
  }),
  watch: {
    'formData.company_id'(newCompanyId) {
      if (newCompanyId) {
        this.fetchCompanyName(newCompanyId)
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.user,
      isEdit: state => state.add_edit_order_modal.isEdit,
      popularTags: state => state.tags.popularTags,
      withCreateActiveOrderProduct: state => state.add_edit_order_modal.withCreateActiveOrderProduct,
    }),
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      catalogProducts: 'catalog_products/catalogProducts',
      onOrderedProducts: 'catalog_products/onOrderedProducts',
      taggedProducts: 'catalog_products/taggedProducts',
      commonMenu: 'menus/commonMenu',
      activeDraftOrder: 'orders/activeDraftOrder',
      newOrderMode: 'orders/newOrderMode',
      newOrderProduct: 'orders/newOrderProduct',
      selectedCollection: 'catalog_products/selectedCollection',
      selectedProducts: 'catalog_products/selectedProducts',
      selectedPopularTagsId: 'catalog_products/getSelectedPopularTagsId',
      currentPage: 'catalog_products/getCurrentPage',
      currentOrderPage: 'orders/currentPage',
      isRep: 'auth/isRep'
    }),
    showBuyerDropdown () {
      if (this.isAdmin || this.isRep) return true
      if (!this.buyerItems || this.buyerItems.length !== 1) return true
      return this.buyerItems[0].user_id !== this.authUser?.id
    }
  },
  methods: {
    ...mapActions({
      fetchCatalogProducts: 'catalog_products/fetchCatalogProducts',
      fetchProductDetails: 'catalog_products/fetchProductDetails',
      copyOrderToNewOrder: 'orders/copyOrderToNewOrder',
      deleteBulkProductFromOrder: 'checkout/deleteBulkProductFromOrder',
      fetchProductItemsOrderSummary: 'checkout/fetchProductItemsOrderSummary',
      fetchOrders: 'orders/fetchOrders',
      fetchCompletedOrders: 'orders/fetchCompletedOrders',
      addProducts: 'orders/addProducts',
      addProduct: 'orders/addProduct',
      newOrder: 'orders/newOrder',
      getCompany: 'company/getCompany',
      getCompanyById: 'company/getCompanyById',
      getNewOrderModalData: 'orders/getNewOrderModalData',
      toggleCatalogProductsProperty: 'catalog_products/toggleCatalogProductsProperty',
      clearActiveDraftOrder: 'orders/clearActiveDraftOrder',
      clearNewOrderProduct: 'orders/clearNewOrderProduct'
    }),
    ...mapMutations({
      setActiveDraftOrder: 'orders/SET_ACTIVE_DRAFT_ORDER',
      setAddEditOrderModalWithCreateActiveOrderProduct: `add_edit_order_modal/${SET_ADD_EDIT_ORDER_MODAL_WITH_CREATE_ACTIVE_ORDER_PRODUCT}`,
      clearSelectedProducts: `catalog_products/${CLEAR_SELECTED_PRODUCTS}`
    }),
    async fetchCompanyName(companyId) {
      try {
        const { data } = await this.getCompanyById(companyId)
        this.companyName = data?.data?.company_info?.name || 'N/A'
      } catch (error) {
        console.error('Error fetching company name:', error)
      }
    },
    onEditContactBtnClicked () {
      this.$router.push({
        name: 'contacts.edit',
        params: {
          id: this.formData.company_id
        }
      })
      this.$modal.hide('new-order-modal')
    },
    onNewContactBtnClicked () {
      this.$router.push({ name: 'contacts.create' })
      this.$modal.hide('new-order-modal')
    },
    async handleSaveNewOrder () {
      const formData = {
        ...this.formData,
        start_ship_date: this.formData.start_ship_date ? dayjs(this.formData.start_ship_date).format('YYYY-MM-DD HH:mm:ss') : null,
        status: ORDER_STATUS.DRAFT
      }
      if (this.withCreateActiveOrderProduct) {
        formData.with_create_active_order_product = 1
        formData.product_id = this.newOrderProduct.id
        formData.variations = this.newOrderProduct.products
      }
      this.formLoading = true
      if (this.$route.name === 'checkout-proceed.order-summary') {
        const payload = {
          ...formData,
          product_ids: this.productIds,
          active_order_id: this.activeDraftOrder?.id
        }
        try {
          if (this.actionType === 'copy') {
            await this.copyOrderToNewOrder(payload)
            this.$toast.success('Successfully copied to the new order.')
          }

          if (this.actionType === 'move') {
            await this.copyOrderToNewOrder(payload)
            const orderId = this.activeDraftOrder?.id
            await this.deleteBulkProductFromOrder({ orderId, productIds: this.productIds })
            await this.fetchProductItemsOrderSummary()
            this.$toast.success('Successfully Moved to the new order.')
          }
          await this.fetchOrders({ page: this.currentOrderPage })
          this.$emit('update:actionType', null)
          this.formLoading = false
          this.initialFormDataState()
          this.$modal.hide(this.modalName)
          if (this.actionType === 'copy' || this.actionType === 'move') {
            // Exit early when actionType is 'copy' or 'move'
            return
          }
        } catch (e) {}
      }

      const response = await this.newOrder(formData)
      this.setActiveDraftOrder(response.data.id)
      try {
        if (this.newOrderMode == 'addSelectedProducts' && this.selectedProducts.length > 0) {
          await this.addProducts({
            orderId: response.data.id,
            productIds: this.selectedProducts.map(product => product.id)
          })
          this.clearSelectedProducts()
        }
        if (this.newOrderProduct && this.newOrderProduct.products && this.newOrderProduct.products.length > 0) {
          const uniqueProductIds = new Set()

          this.newOrderProduct.products.forEach((product) => {
            if (!uniqueProductIds.has(product.product_id)) {
              uniqueProductIds.add(product.product_id)
              this.toggleCatalogProductsProperty({
                property: 'active_order',
                products: [{ id: product.product_id }]
              })
            }
          })
        }

        if (this.newOrderProduct?.product_ids && this.newOrderProduct?.product_ids.length > 0) {
            this.newOrderProduct.product_ids.forEach((product_id) => {
                  this.toggleCatalogProductsProperty({
                    property: 'active_order',
                    products: [{ id: product_id }]
                  })
            })
        }

        if (this.$route.name === 'order-history.index') {
          const url = '/api/order?order_status=2,3'
          await this.fetchCompletedOrders({ page: 1, url })
        } else {
          await this.fetchOrders({ page: this.currentOrderPage })
        }
        if (this.$route.name === 'tag-module') {
          /** TODO : get selected popular tag's or my tags products */
          const { selected, ...filteredParams } = { ...this.$route.query }
          selected === 'my_tags' ? delete filteredParams.tag_ids : delete filteredParams.my_tags_only
          filteredParams.page = this.currentPage
          const apiRoute = `/api/product?${new URLSearchParams(filteredParams).toString()}`
          this.fetchCatalogProducts({ urlEndpoint: apiRoute, isChange: true })
        } else if (this.$route.name === 'collections' && this.newOrderProduct == null) {
            const page = this.currentPage
            const apiRoute = `/api/product?collection_id=${this.selectedCollection?.id}&page=${page}`
            await this.fetchCatalogProducts({ urlEndpoint: apiRoute, isCollectionsPage: true })
        }
      } catch (e) {
         console.log(e)
      }
      if (this.newOrderMode === 'emptyOrder') {
        await this.fetchProductItemsOrderSummary()
      }
      this.initialFormDataState()
      this.closeModal()
      this.formLoading = false
      if (formData.product_id) {
        await this.fetchProductDetails({
          id: formData.product_id,
          activeCollection: 0,
          activeOrderId: response.data.id
        })
      }
    },
    closeModal () {
      this.onlyCloseModal()
      this.$modal.hide(this.modalName)
    },
    async onlyCloseModal () {
      await this.fetchOrders({ page: this.currentOrderPage })
      this.setAddEditOrderModalWithCreateActiveOrderProduct(false)
      // For collections implementation
      if (!this.activeDraftOrder && this.onOrderedProducts.length) {
        this.toggleCatalogProductsProperty({
          property: 'active_order',
          products: [this.catalogProducts.find(item => item.id === this.onOrderedProducts[0].id)]
        })
      }

      this.clearNewOrderProduct()
      // for checkout implementations
      if (this.newOrderProduct !== null &&
          this.activeDraftOrder !== null &&
          Object.keys(this.activeDraftOrder).length &&
          Object.keys(this.newOrderProduct).length) {
        this.toggleCatalogProductsProperty({
          property: 'active_order',
          products: [this.catalogProducts.find(item => item.id === this.newOrderProduct.id)]
        })
        return
      }

      if (this.$route.name === 'products') {
        const params = { ...this.$route.query }
        params.page = this.currentPage
        this.fetchCatalogProducts({ urlEndpoint: `/api/product?${new URLSearchParams(params).toString()}` })
      }
    },
    async fetchNewOrderModalData () {
      const { data } = await this.getNewOrderModalData()
      this.companyItems = this.formattedCompanies(data.companies)
      this.initialFormDataState()
      if (!(this.isAdmin || this.isRep) && this.companyItems.length > 0) {
        const companyId = this.companyItems[0].id
        this.changeCompany(companyId)
      }
      if (this.$route.name === 'contacts.edit') {
        const companyId = this.$route.params.id
        this.changeCompany(companyId)
      }
    },
    initialFormDataState () {
      this.billToItems = []
      this.shipToItems = []
      this.buyerItems = []
      this.formData = {
        company_id: null,
        shipping_address_id: null,
        billing_address_id: null,
        buyer_id: null,
        start_ship_date: null,
        ref_note: '',
        discount: 0,
        shipper: this.authUser.first_name + ' ' + this.authUser.last_name
      }
    },
    async changeCompany (companyId) {
      const { data: { data } } = await this.getCompanyById(companyId)
      this.shipToItems = data?.addresses.filter(item => Boolean(item.is_shipping_address)).map(a => ({ ...a, optionLabel: a.address_one })) || []
      this.billToItems = data?.addresses.filter(item => Boolean(item.is_billing_address)).map(a => ({ ...a, optionLabel: a.address_one })) || []
      this.buyerItems = data?.buyers.map(a => ({ ...a, optionLabel: a.id })) || []
      this.companyInfo = data?.company_info

      const defaultShipAddress = this.shipToItems.find(item => item.is_default)
      const defaultBillAddress = this.billToItems.find(item => item.is_default)

      this.formData.company_id = companyId
      this.formData.shipping_address_id = defaultShipAddress ? defaultShipAddress?.address_id : null
      this.formData.billing_address_id = defaultBillAddress ? defaultBillAddress?.address_id : null
      this.formData.buyer_id = this.resolveDefaultBuyerId(this.buyerItems)
      this.formData.start_ship_date = null
      this.formData.ref_note = ''
      this.formData.payment_terms = this.companyInfo?.payment_terms
      // Account logins seed their order note from the account alert note; staff-keyed (MOS) orders
      // start blank so the internal alert note never reaches the customer's confirmation.
      if (!this.isAdmin && !this.isRep) {
        this.formData.order_note = this.companyInfo?.alert_note ?? ''
      }
      /*    this.formData.discount = this.companyInfo?.default_discount_amount */
    },
    clearOrder () {
      const order = localStorage.getItem('activeDraftOrderId')
      if (order === 'addOneProduct' || order === 'emptyOrder' || order === 'addSelectedProducts') {
        this.clearActiveDraftOrder()
      }
    },
    resolveDefaultBuyerId (buyerItems) {
      if (!buyerItems || buyerItems.length === 0) return null

      const flagged = buyerItems.find(item => item.is_default)
      if (flagged) return flagged.buyer_id

      if (!this.isAdmin && !this.isRep) {
        const self = buyerItems.find(item => item.user_id === this.authUser?.id)
        if (self) return self.buyer_id
        if (buyerItems.length === 1) return buyerItems[0].buyer_id
      }

      return null
    },
    formattedCompanies(companies) {
          return companies.flatMap((company) => {
              if (!company.addresses || company.addresses.length === 0) {
                  const companyName = company.name.length > 40 ? company.name.substring(0, 40) + "..." : company.name

                  return {
                      id: company.id,
                      name: `${companyName} | N/A, N/A`,
                  }
              }

              return company.addresses.map((address) => {
                  const companyName = company.name.length > 30 ? company.name.substring(0, 40) + "..." : company.name
                  const city = address.address_one ? address.address_one : 'N/A'
                  const state = address.state ? address.state : 'N/A'

                  return {
                      id: company.id,
                      name: `${companyName} | ${city}, ${state}`,
                  }
              })
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.new-order-modal {
  padding: 20px 30px;
  .contact-buttons {
    justify-content: flex-end;
  }

    .new-order-modal-form {
        ::v-deep {
            .label-form {
                font: normal normal normal 13px/15px Arial;
                letter-spacing: 0px;
                color: #000000;
            }
        }

    }

  .button-group {
    .cancel-btn {
      padding: 10px 0; width: 145px; background: #909090; border: 1px solid #909090
    }
  }
  .form-control,
  .form-select {
    background-color: #ffffff;
  }

  .form-select {
    white-space: normal;
  }
}

::v-deep {
    .p-v-select {
        ul {
            height: 95px;
        }
        .label-row-container, .selected-option {
            p {
                font: normal normal normal 14px/18px Arial;
                color: #000000;
                margin: 0;
                white-space: normal;
                word-break: break-word;
            }
        }
    }

  .start-ship {
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 0.9719999432563782px solid #dadada;
    font: normal normal normal 14px/18px Arial;
    letter-spacing: 0px;
    color: #000000;
    padding: 11px 15px;
  }

  .vm--modal {
      overflow: unset !important;
  }
}
@media screen and (max-width: 720px) {
  .contact-buttons {
    justify-content: center !important;
    padding-bottom: 11px;
  }
}
</style>
<style>
.header-container {
  .vm--container {
    z-index: 9999999999 !important;
  }
}
.new-order-modal-container
    .vm--modal {
      max-height: 100% !important;
      overflow: auto !important;
      padding-top: 10px;
    }

@media (max-width: 767.98px) {
  .new-order-modal-container .vm--modal {
    position: fixed !important;
    left: 16px !important;
    right: 16px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: auto !important;
    max-width: none !important;
    height: auto !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
  }
}

@media (max-width: 480px) {
  .new-order-modal-container .vm--modal {
    left: 12px !important;
    right: 12px !important;
    max-height: 92vh !important;
  }
}
</style>
